<template>

    <div class="first-stack need-padding">
        <div class="first-stack-left">
            <div class="title-group">
                <span class="title">ZHANG <span class="subfont">ADIL </span></span>
                <span class="title">LEEUU <span class="highlight">PLATFORM </span></span>
            </div>
            <div class="discription">
                <span class="discription-text">浪漫庄园综合站点,便利且全面的内容。<br> <span class="subfont">备受玩家喜爱。</span></span>
            </div>
            <div class="first-stack-links">
                <router-link :icon="Download" :underline="false" to="/about"
                    style="background:var(--adil-theme-op-deep)" class="about-button">关于本站</router-link>
            </div>
        </div>
        <div class="first-stack-right">
            <el-carousel height="400px" :interval="5000" arrow="hover" indicator-position="none"
                class="carousel-container">
                <el-carousel-item v-for="item in carouselItems" :key="item.id" @click="handleCarouselClick(item.link)"
                    class="carousel-item">
                    <div class="carousel-content">
                        <div class="carousel-text">
                            <h3 class="carousel-title">{{ item.title }}</h3>
                            <p class="carousel-description">{{ item.description }}</p>
                        </div>
                        <img :src="item.image" :alt="item.title" class="carousel-image">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>

</template>

<script>

export default {
    name: "HomePage",
    components: {
    },
    data() {
        return {
            carouselItems: [
                {
                    id: 1,
                    title: "价格查询",
                    description: "快速查询游戏物品价格，轻松把握市场动态。",
                    image: require("@/assets/home.png"),
                    link: "/price"
                },
                {
                    id: 2,
                    title: "游戏攻略",
                    description: "专业的游戏攻略，助你快速成长。",
                    image: require("@/assets/jineng.png"),
                    link: "/tutorial"
                },
                {
                    id: 3,
                    title: "实用工具",
                    description: "便利的游戏工具，只为让你更好享受。",
                    image: require("@/assets/tools.png"),
                    link: "/tools"
                },
                {
                    id: 4,
                    title: "整体展示",
                    description: "全面的图纸展示，总有你想要的。",
                    image: require("@/assets/show.png"),
                    link: "/designer"
                }
                
            ]
        }
    },
    methods: {
        handleCarouselClick(link) {
            this.$router.push(link);
        }
    }
}
</script>

<style>
.need-padding {
    max-width: 1200px;
    width: 90%;
    z-index: 1;
}

.first-stack-left {
    display: flex;
    flex-direction: column;
    align-items: start;
    height: 500px;
    padding: 40px 0;
    position: relative;
}

.first-stack {
    display: flex;
    justify-content: space-between;
    height: calc(100vh - 41px);
    align-items: center;
    margin: 0;
}

.title-group {
    display: flex;
    flex-direction: column;
    font-size: 68px;
    color: #00001e;
    font-weight: 700;
    font-family: system-ui;
    letter-spacing: 0;
    line-height: 75px;
    text-shadow: 0 9px 41px rgba(0, 0, 0, .12);
}

span.subfont {
    color: var(--adil-secondtext);
}

span.highlight {
    background-image: -webkit-linear-gradient(241deg, #ea6044 39%, #dc5083 50%, #9a6df7 67%, #3f8def 81%);
    background-image: linear-gradient(209deg, #ea6044 39%, #dc5083 50%, #9a6df7 67%, #3f8def 81%);
    -webkit-background-clip: text;
    background-clip: text;
    position: relative;
    color: transparent
}

.discription {
    margin-top: 24px;
}

span.discription-text {
    display: block;
    font-size: 28px;
    color: #00001e;
    line-height: 38px;
    font-weight: 700;
}

.first-stack-links {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 32px;
}

a.about-button {
    display: flex;
    padding: 11px 21px;
    background: var(--adil-card-btn-bg);
    color: var(--adil-white);
    border-radius: 29px;
    box-shadow: 0 12px 12px -9px rgba(0, 0, 0, .29);
    width: fit-content;
    transition: .3s ease-in-out;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
}

a.about-button:hover {
    background: var(--adil-main);
    --el-link-hover-text-color: var(--adil-white);
    box-shadow: 0 12px 12px -9px rgba(5, 51, 137, .29);
}

.first-stack-right {
    flex: 1;
    margin-left: 40px;
    max-width: 600px;
}

.carousel-container {
    width: 100%;
    height: 500px !important;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: var(--adil-shadow-border);
}

.carousel-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    color: var(--adil-fontcolor);
}

.carousel-text {
    text-align: center;
    width: 100%;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 0;
}

.carousel-title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 12px;
    color: var(--adil-fontcolor);
}

.carousel-description {
    font-size: 18px;
    color: var(--adil-secondtext);
    margin-bottom: 0;
    text-align: center;
}

.carousel-image {
    width: 90%;
    height: calc(100% - 120px);
    object-fit: contain;
    display: block;
    margin-top: 20px;
}

.carousel-item {
    cursor: pointer;
}

.carousel-item:hover .carousel-title {
    color: var(--adil-theme);
    transition: color 0.3s ease;
}

@media (max-width: 768px) {
    .first-stack {
        flex-direction: column;
        height: auto;
        min-height: calc(100vh - 41px);
        padding: 40px 0;
    }

    .first-stack-right {
        margin-left: 0;
        margin-top: 40px;
        width: 100%;
    }

    .carousel-container {
        height: 400px !important;
    }

    .carousel-content {
        padding: 20px;
    }

    .carousel-text {
        padding: 5px 0;
    }

    .carousel-image {
        height: calc(100% - 100px);
        margin-top: 10px;
    }

    .title-group {
        font-size: 32px;
        line-height: 50px;
    }

    .first-stack-left {
        height: auto;
        padding: 20px 0;
    }

    .discription {
        margin-top: 16px;
    }

    .first-stack-links {
        margin-top: 20px;
    }

    span.discription-text {
        font-size: 14px;
        line-height: 28px;
        margin-top: 5px;
    }

    a.about-button {
        padding: 8px 16px;
        margin-top: 40px;
    }
}
</style>